/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_no_teams_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No teams fit within your budget`)
};

const es_f1_apex_no_teams_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún equipo cabe dentro de tu presupuesto`)
};

const de_f1_apex_no_teams_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Team passt in dein Budget`)
};

const nl_f1_apex_no_teams_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen enkel team past binnen je budget`)
};

const fr_f1_apex_no_teams_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune équipe ne rentre dans votre budget`)
};

const it_f1_apex_no_teams_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun team rientra nel tuo budget`)
};

const pt_br2_f1_apex_no_teams_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma equipe cabe dentro do seu orçamento`)
};

const pt_f1_apex_no_teams_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma equipa cabe dentro do seu orçamento`)
};

const ja_f1_apex_no_teams_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予算内に収まるチームがありません`)
};

const zh_f1_apex_no_teams_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有车队能在您的预算内`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_no_teams_budget = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_no_teams_budget(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_no_teams_budget", locale)
	if (locale === "en") return en_f1_apex_no_teams_budget(inputs)
	if (locale === "es") return es_f1_apex_no_teams_budget(inputs)
	if (locale === "de") return de_f1_apex_no_teams_budget(inputs)
	if (locale === "nl") return nl_f1_apex_no_teams_budget(inputs)
	if (locale === "fr") return fr_f1_apex_no_teams_budget(inputs)
	if (locale === "it") return it_f1_apex_no_teams_budget(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_no_teams_budget(inputs)
	if (locale === "pt") return pt_f1_apex_no_teams_budget(inputs)
	if (locale === "ja") return ja_f1_apex_no_teams_budget(inputs)
	return zh_f1_apex_no_teams_budget(inputs)
};